import Navbar from './navbar';
import Textform from './textform';
import './App.css';
import { useState } from 'react';
function App() {
      const [mode, setmode] = useState('dark');
      const togglemode = () => {
            if (mode === 'dark') {
                  setmode('light');
                  document.title = 'Text Formatter | DarkMode';
                  document.body.style.backgroundColor = '#042743';
            }
            else {
                  setmode('dark');
                  document.title = 'Text Formatter | Home';
                  document.body.style.backgroundColor = 'white';
            }
      }
      return (
            <>
                  <Navbar mode={mode} togglemode={togglemode} />
                  <div className="container my-3">
                        <Textform mode={mode} />
                  </div>
                  <footer className="footer">
                        <p className="centered-text">Made with <i class='bx bxs-heart' ></i> by <a className="myname" href="www.linkedin.com/in/nailwalnikhil">Nikhil Nailwal</a></p>
                  </footer>

            </>
      );
}

export default App;
